import { Score } from "../../types";

export function wordIsCorrect({
  score,
  stepIndex,
  wordId
}: {
  score: Score;
  stepIndex: number;
  wordId: string;
}) {
  return score.steps[stepIndex] && score.steps[stepIndex][wordId];
}
